import * as yup from "yup";

import {
    validationTextField,
    validationStringSelect
  } from "./defaultValidations";


  export default yup.object({
    roleTitle: validationTextField("Role Title", 3, 127),
    // roleRemark: validationTextField("Role Remark", 3, 200),
    status: validationStringSelect("Status"),
  });
  